import React, {Component} from 'react';
import { connect } from 'dva';
import { Select } from 'antd';
import BaseComponent from '../../../components/BaseComponent';

const {Option} = Select;

class FilterCity extends BaseComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(value){
    const {dispatch} = this.props;

    dispatch({
      type: 'travel/filterCity',
      value: value
    });
  }

  render() {
    const {travel} = this.props;
    const {tMeta} = travel;

    return(
      <div>
      <Select
        style={{ width: '100%' }}
        placeholder="行先で選択"
//        defaultValue={school.filterVisa}
        optionFilterProp="children"
        onChange={this.onChange}
      >
        <Option value='all' key='all'>すべて</Option>
        {tMeta.cities &&
         tMeta.cities.map(city => (
          <Option value={city.key} key={city.key}>{city.label}</Option>
         ))
        }
      </Select>
      </div>
    )
  }
}

export default connect(({ travel }) => ({
  travel
}))(FilterCity);



// WEBPACK FOOTER //
// ./src/pages/travel/components/FilterCity.js